// Settings: the routes and the sidebar rows of `wealth.platform.settings` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.platform.settings',
    routes: [
        { frontend: 'desk', path: 'settings', lazy: () => import('@/pages/desk/settings/page') },
        { frontend: 'ops', path: 'settings', lazy: () => import('@/pages/ops/settings/page') },
        {
            frontend: 'comply',
            path: 'settings',
            lazy: () => import('@/pages/comply/settings/page'),
        },
        { frontend: 'view', path: 'settings', lazy: () => import('@/pages/view/settings/page') },
        { frontend: 'admin', path: 'settings', lazy: () => import('@/pages/admin/settings/page') },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'settings',
            label: 'Settings',
            href: '/comply/settings',
            icon: 'Settings',
            group: 'system',
            order: 910,
        },
        // --- System ---
        {
            frontend: 'desk',
            key: 'settings',
            label: 'Settings',
            href: '/desk/settings',
            icon: 'Settings',
            group: 'system',
            order: 710,
        },
        {
            frontend: 'ops',
            key: 'settings',
            label: 'Settings',
            href: '/ops/settings',
            icon: 'Settings',
            group: 'system',
            order: 810,
        },
        {
            frontend: 'view',
            key: 'settings',
            label: 'Settings',
            href: '/view/settings',
            icon: 'Settings',
            group: 'system',
            order: 820,
        },
        {
            frontend: 'admin',
            key: 'settings',
            label: 'Settings',
            href: '/admin/settings',
            icon: 'Settings',
            group: 'system',
            order: 900,
        },
    ],
});
